// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._material-design-icon_zYnoU{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}._iconToggleSwitch_hhj0H{color:var(--v6bd152af);transition:color var(--animation-quick) ease}._iconToggleSwitch_hhj0H svg{height:auto !important}._iconToggleSwitch_hhj0H circle{cx:var(--v16fd8ca9);transition:cx var(--animation-quick) ease}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
